import React from 'react';
import { useWindowResize } from '../../../hooks/helpers/useWindowResize';
import i18n from '../../../i18n';
import { Button } from './ButtonDefault.style';

type ButtonDefaultProps = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export const ButtonDefault = ({ onClick }: ButtonDefaultProps) => {
  const { isMobile } = useWindowResize();

  return (
    <Button
      size={isMobile ? 'medium' : 'large'}
      width="flexible"
      aria-label={i18n.t('spotlight:default.button')}
      onClick={onClick}
    >
      {i18n.t('spotlight:default.button')}
    </Button>
  );
};
